module.exports = __webpack_public_path__ + "static/media/rainy-6.f1fe2b22.svg";